import * as React from "react";
const Calendar = (props) => (
    <svg
        width={20}
        height={21}
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M13.958 3.467v-1.3a.63.63 0 0 0-.625-.625.63.63 0 0 0-.625.625v1.25H7.292v-1.25a.63.63 0 0 0-.625-.625.63.63 0 0 0-.625.625v1.3c-2.25.208-3.342 1.55-3.509 3.541a.42.42 0 0 0 .417.442h14.1c.242 0 .442-.208.417-.442-.167-1.992-1.259-3.333-3.509-3.541M16.667 8.7H3.333a.836.836 0 0 0-.833.833v5.134c0 2.5 1.25 4.166 4.167 4.166h6.666c2.917 0 4.167-1.666 4.167-4.166V9.532a.836.836 0 0 0-.833-.833"
            fill={props.color || "#BAC2C3"}
        />
    </svg>
);
export default Calendar;
